import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CONTService {
    private http: Http;

    constructor(http: Http) {
        this.http = http;
    }

    public newCONT(): Observable<Response> {
        return this.http.get("http://services.stefan-wimmer.de/api/CONTes/1");
    }

    public addCont(cont: any): Observable<Response> {
        return this.http.post("http://services.stefan-wimmer.de/api/CONTes", cont)
    }

}
